import { Logout as LogoutIcon } from '@mui/icons-material';
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Chip,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Inventory as InventoryIcon,
  SwapHoriz as SwapHorizIcon,
  People as PeopleIcon,
  PointOfSale as PointOfSaleIcon,
  Person as PersonIcon,
  Help as HelpIcon,
  AdminPanelSettings as AdminIcon,
} from '@mui/icons-material';

const drawerWidth = 240;

function Layout({ children, onLogout }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Obtener usuario y rol del localStorage
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const rol = user.rol || 'vendedor';
  const esAdmin = rol === 'admin';

  // Menú items según rol
  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/', visible: true },
    { text: 'Ventas', icon: <PointOfSaleIcon />, path: '/ventas', visible: true },
    { text: 'Clientes', icon: <PeopleIcon />, path: '/clientes', visible: true },
    { text: 'Productos', icon: <InventoryIcon />, path: '/productos', visible: esAdmin },
    { text: 'Kardex', icon: <SwapHorizIcon />, path: '/kardex', visible: esAdmin },
    { text: 'Mi Perfil', icon: <PersonIcon />, path: '/perfil', visible: true },
    { text: 'Ayuda', icon: <HelpIcon />, path: '/ayuda', visible: true },
    { text: 'Usuarios', icon: <PeopleIcon />, path: '/usuarios', visible: esAdmin },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <Toolbar>
        <Typography variant="h6" noWrap sx={{ fontWeight: 'bold', color: '#1976d2' }}>
          EJARAD-TIC
        </Typography>
      </Toolbar>
      
      {/* Info del usuario y rol */}
      <Box sx={{ px: 2, pb: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          {user.nombre || 'Usuario'}
        </Typography>
        <Chip 
          label={esAdmin ? 'Administrador' : 'Vendedor'} 
          size="small" 
          color={esAdmin ? 'primary' : 'default'}
          icon={esAdmin ? <AdminIcon sx={{ fontSize: 16 }} /> : undefined}
          sx={{ mt: 0.5, height: 24 }}
        />
      </Box>
      
      <Divider />
      
      <List>
        {menuItems
          .filter(item => item.visible)
          .map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                selected={location.pathname === item.path}
                onClick={() => {
                  navigate(item.path);
                  setMobileOpen(false);
                }}
              >
                <ListItemIcon sx={{ color: location.pathname === item.path ? '#1976d2' : 'inherit' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
      
      <Divider />
      
      <Box sx={{ p: 2, mt: 'auto' }}>
        <Typography variant="caption" color="text.secondary">
          Sistema de Gestion Comercial
        </Typography>
        <Typography variant="caption" display="block" color="text.secondary">
          v1.0.0 | Piura 2026
        </Typography>
      </Box>
    </div>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: '#1976d2',
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Sistema Web Integral - Gestion Comercial
          </Typography>
        </Toolbar>
      </AppBar>
      
      <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
          <Divider />
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={onLogout}>
                <ListItemIcon sx={{ color: '#d32f2f' }}>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary="Cerrar Sesión" sx={{ color: '#d32f2f' }} />
              </ListItemButton>
            </ListItem>
          </List>
        </Drawer>
      </Box>
      
      <Box component="main" sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}

export default Layout;